import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/lib/components/google-analytics-defer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextUIProvider"] */ "/opt/buildhome/repo/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/buildhome/repo/packages/ui/src/toaster.tsx");
